export default __webpack_public_path__ + "static/media/nice.178c0813.png";